module.exports = __webpack_public_path__ + "media/images/lig/icon-shirt-2458c2da50c2396cfa5cd5aefa654006.svg";